import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ChatFilled: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 24) / 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.653999 3.44371C-8.82149e-07 4.79287 -9.53674e-07 6.55901 -9.53674e-07 10.0913V11.585C-9.53674e-07 13.7158 -1.36495e-06 14.7811 0.242399 15.6502C0.817439 17.7115 2.3508 19.3233 4.31172 19.9278C5.13852 20.1826 6.15192 20.1826 8.17896 20.1826H8.83752L8.91564 20.1827C10.1399 20.1909 11.3326 20.5927 12.3334 21.334L12.397 21.3817L15.5298 23.7339C16.6038 24.5402 18.0151 23.3757 17.5249 22.0877C17.1777 21.1752 17.817 20.1826 18.7519 20.1826H19.474C21.9736 20.1826 24 18.0526 24 15.4249V10.0913C24 6.55901 24 4.79287 23.346 3.44371C22.7708 2.25697 21.8529 1.2921 20.7239 0.687431C19.4405 7.51859e-08 17.7603 0 14.4 0H9.6C6.23964 0 4.55952 7.51859e-08 3.276 0.687431C2.14704 1.2921 1.22916 2.25697 0.653999 3.44371ZM16.8 6.62241C17.2971 6.62241 17.7 7.04598 17.7 7.56846C17.7 8.09095 17.2971 8.51452 16.8 8.51452H12C11.503 8.51452 11.1 8.09095 11.1 7.56846C11.1 7.04598 11.503 6.62241 12 6.62241H16.8ZM16.8 11.6681C17.2971 11.6681 17.7 12.0916 17.7 12.6141C17.7 13.1366 17.2971 13.5602 16.8 13.5602H7.2C6.70296 13.5602 6.3 13.1366 6.3 12.6141C6.3 12.0916 6.70296 11.6681 7.2 11.6681H16.8Z"
        fill="currentColor"
      />
    </svg>
  )
})

ChatFilled.displayName = 'ChatFilled'
